import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../api/api";

export default function ProjetosList() {
  const [projetos, setProjetos] = useState([]);

  useEffect(() => {
    apiGet("/projetos/").then(setProjetos);
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h1>Projetos</h1>

      <Link to="/projetos/novo">
        <button>Novo Projeto</button>
      </Link>

      <ul>
        {projetos.map((p) => (
          <li key={p.id}>
            <Link to={`/projetos/${p.id}`}>
              {p.nome} — {p.cliente}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
